import React from "react";
import {
    createTheme,
    ThemeProvider,
    Box,
    Container,
    Grid,
    Typography,
    Link as MuiLink
} from '@mui/material';
import '../ATC-Cluster/Emea.css';
import FocusAreaApac from "./FocusAreaApac";

const Apac = () => {
    const localTheme = createTheme({
        typography: {
            fontFamily: 'Graphik-Regular, sans-serif',
        },
    });

    const regions = [
        {
            title: 'APAC',
            countries: ['Malaysia', 'Indonesia', 'Vietnam'],
            images: ['images/Home/malaysia.png', 'images/Home/indonesia.png', 'images/Home/Vietnam.png']
        },
    ];

    return (
        <>
            <ThemeProvider theme={localTheme}>
                {/* Banner */}
                <div className="main-banner">
                    <img
                        src="images/Home/banner-home.png"
                        alt="banner"
                        className="banner-img"
                    />
                </div>

                <Container maxWidth={false} disableGutters>
                    <Box sx={{ width: "90%", margin: "auto" }}>
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 2, mb: 2 }}>
                        <MuiLink href="/home" underline="hover">
                            <img src="images/Home/home_icon.png" alt="Home" className="home-icon" />
                        </MuiLink>/ <span style={{ textDecoration: 'underline' }}>APAC</span>
                    </Typography>
                    </Box>
                    <Box className="coverage_box">
                                       <Box sx={{ width: "90%", margin: "auto", position: "relative" }}>
                                       <Typography variant="h4" color="primary" gutterBottom className="atc-header">
                                           Coverage in APAC
                                       </Typography>
                            <div className="header_line">
                                <img src="images/Home/header_line.png" alt="header_line" className="header_line_img" />
                            </div>
                                       <Grid container spacing={4} className="coverage_grid">
                                           {regions.map((region) => (
                                               <Grid item xs={12} md={6} key={region.title}>
                                                   <Box className="coverage_card">
                                                       <img
                                                           src="images/Home/bg_img_card.png"
                                                           alt="card background"
                                                           className="card_img"
                                                       />
                                                       <h3 className="region_header">{region.title}</h3>
                   
                                                       <Box className="country_list1">
                                                           {region.countries.map((country, i) => (
                                                               <Box key={country} className="country_item">
                                                                   <img
                                                                       src={region.images[i]}
                                                                       alt={country}
                                                                       className="flag_icon"
                                                                   />
                                                                   <Typography variant="body2" className="country_name">
                                                                       {country}
                                                                   </Typography>
                                                               </Box>
                                                           ))}
                                                       </Box>
                                                   </Box>
                                               </Grid>
                                           ))}
                                       </Grid>
                                       </Box>
                                   </Box>
                </Container>
                <FocusAreaApac/>
            </ThemeProvider>
        </>
    );
};

export default Apac;
